import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
    RenderButtonField, RenderCloseField, RenderTextField
} from "../../components/renderField";
import React, {useState} from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ExportPage from "../modal/ExportPageModal";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
export function PickupBar({searchData, setSearchData, search, setSearch, setCurrentPage}) {
    const [searchOpen, setSearchOpen] = useState(true);
    const handleSubmit = (e) => {
        e.preventDefault(); // 阻止表单默认提交行为
        setCurrentPage(0);
        setSearch()
    }

    const handleFieldChange = (fieldName) => (event) => {
        setSearchData({ ...searchData, [fieldName]: event.target.value });
    };

    const handleClearData = () => {
        setSearchData({
            pickup_code: "", tracking_number: ""
        });
    };

    const toggleSearchOpen = () => {
        setSearchOpen(!searchOpen);
    };

    return (
        <div>
            {!searchOpen && (
                <Button
                    sx={{ textTransform: 'none' }}
                    startIcon={<SearchIcon />}
                    onClick={() => toggleSearchOpen()}
                    variant="text">
                    搜索
                </Button>
            )}
            {searchOpen && (
                <Box component="form" onSubmit={handleSubmit} noValidate>
                    <Paper sx={{p: 1}}>
                    <Grid container style={{marginBottom: "1%"}}>
                        <RenderTextField
                            idAname="pickup_code"
                            label="预约码"
                            value={searchData.pickup_code}
                            onChangeHandler={handleFieldChange('pickup_code')}
                        />
                        <RenderTextField
                            idAname="tracking_number"
                            label="运单号查询"
                            value={searchData.tracking_number}
                            onChangeHandler={handleFieldChange('tracking_number')}
                        />
                    </Grid>
                    <Grid container>
                        <RenderButtonField
                            idAname="Search"
                            variant="contained"
                            text="查询"
                            buttonType="submit"
                            tip="条件查询"
                            onClickHandler={null}
                            loading={search}
                        />
                        <RenderButtonField
                            idAname="Clear"
                            variant="outlined"
                            text="清空"
                            buttonType="button"
                            tip="清空查询信息"
                            onClickHandler={handleClearData}
                        />
                        <RenderCloseField onClickHandler={() => setSearchOpen(false)} />

                    </Grid>
                    </Paper>
                </Box>
            )}
        </div>
    )
}

